<loading-indicator *ngIf="!formReady"></loading-indicator>
<div [formGroup]="formData" class="form-host" *ngIf="formReady">
  <div class="projectsSearchFormContainer">
    <div class="searchFormContainerLeft">
      <table aria-hidden="true">
        <tbody>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'projectstd.puid' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-numerictextbox style="width: 100%;" formControlName="puid" format="#" [spinners]="false"></kendo-numerictextbox>
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'projectstd.name' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <input type="text" formControlName="projectName" />
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'projectstd.client' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <input type="text" formControlName="client" />
            </td>
          </tr>
          <tr>
            <td class="LabelContainer dialogTableCellPaddingTop">
              <span class="dialogLabel uppercase">{{ 'projectstd.status' | translate }}</span>
            </td>
          </tr>
          <tr>
            <td class="FieldContainer">
              <kendo-dropdownlist formControlName="projectStatus"
                                  [data]="reflistData.ref_projectphasevaluation"
                                  textField="description"
                                  valueField="oid"
                                  [valuePrimitive]="true">
              </kendo-dropdownlist>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
